type CustomBorderIconProps = React.SVGProps<SVGSVGElement> & {
    style?: React.CSSProperties
}

const BorderRightIcon = ({ style = {}, ...otherProps }: CustomBorderIconProps) => (
    <svg
        width='20'
        height='20'
        viewBox='0 0 257 257'
        fill='currentColor'
        style={{
            display: 'inline-block',
            flexShrink: 0,
            ...style
        }}
        {...otherProps}>

        <rect className='st0' x='160.59' y='32.11' width='21.42' height='21.42' />
        <rect className='st0' x='160.59' y='203.45' width='21.42' height='21.42' />
        <rect className='st0' x='160.59' y='117.78' width='21.42' height='21.42' />
        <rect className='st0' x='117.75' y='32.11' width='21.42' height='21.42' />
        <rect className='st0' x='117.75' y='74.96' width='21.42' height='21.42' />
        <rect className='st0' x='74.93' y='117.78' width='21.42' height='21.42' />
        <path className='st0' d='M224.87,214.16V42.83c0-5.89-4.82-10.71-10.71-10.71s-10.71,4.82-10.71,10.71v171.33c0,5.89,4.82,10.71,10.71,10.71s10.71-4.82,10.71-10.71Z' />
        <rect className='st0' x='74.93' y='32.11' width='21.42' height='21.42' />
        <rect className='st0' x='74.93' y='203.45' width='21.42' height='21.42' />
        <rect className='st0' x='117.75' y='117.78' width='21.42' height='21.42' />
        <rect className='st0' x='117.75' y='203.45' width='21.42' height='21.42' />
        <rect className='st0' x='117.75' y='160.61' width='21.42' height='21.42' />
        <rect className='st0' x='32.1' y='32.11' width='21.42' height='21.42' />
        <rect className='st0' x='32.1' y='74.96' width='21.42' height='21.42' />
        <rect className='st0' x='32.1' y='117.78' width='21.42' height='21.42' />
        <rect className='st0' x='32.1' y='203.45' width='21.42' height='21.42' />
        <rect className='st0' x='32.1' y='160.61' width='21.42' height='21.42' />
    </svg>
)

export default BorderRightIcon
